export default __webpack_public_path__ + "static/product-hero-80ws-2b41f482dc83c86f8cb805b60a0161bd.svg";